const normalizeBase = (value, fallback) => `${value || fallback}`.replace(/\/+$/, "") + "/";

export const API_BASE_URL = normalizeBase(
  process.env.REACT_APP_API_URL,
  "http://localhost:8000/api/",
);

export const ASSET_BASE_URL = normalizeBase(
  process.env.REACT_APP_API_URL_IMAGES,
  "http://localhost:8000/",
);

export const resolveAssetUrl = (path, fallback = "/icone.jpeg") => {
  if (!path) return fallback;
  if (/^(?:https?:|blob:|data:)/i.test(path)) return path;
  return new URL(path.replace(/^\/+/, ""), ASSET_BASE_URL).toString();
};
